import React, { Component }from 'react'
import { compose} from 'recompose'
import {connect} from 'react-redux'
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
//import CardActions from '@material-ui/core/CardActions';
//import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
import {fetchCanidates} from '../../../../actions/adminCanidates'
import {SELECTED_CANIDATE} from '../../../../constants/actionTypes'
//import _ from 'lodash'

const styles = theme => ({
    paper: {
        padding: theme.spacing.unit,
      },
    card: {
        marginBottom: theme.spacing.unit,
        //backgroundColor: 'blue'
        cursor: 'pointer',
        padding: theme.spacing.unit
    },
    cardContent: {
        padding: theme.spacing.unit,
    }
})




class AdminCanidateSelect extends Component {
    constructor(props) {
        super(props);
    
        this.state   = {
            prevId: null,
            
        } //this.toggleView = this.toggleView.bind(this)
    }

    componentDidMount() {
        const { onFetchCanidates, canidatesIds, canidatesOnWait } = this.props
        onFetchCanidates(canidatesOnWait)
        if(typeof(canidatesIds)==='undefined') {
            console.error('canidates are undefined', canidatesIds)
        } else {
                onFetchCanidates(canidatesIds)
          
        }
    }
    
    onClick = (id) => {

        // do the style stuff for selected canidate
        if(this.state.prevId != null){
            this.setState({[this.state.prevId]: {}})
            this.setState({prevId: null})
        }
       
        this.setState({[id]: {color: 'white', backgroundColor: '#3f51b5', border: '1px solid green'}})
        this.setState({prevId: id})
        
        // fetch canidate/user contact details
        this.props.onSelectCanidate(this.props.canidates[id])
        
        }
        renderCanidates = () =>{
            const { canidates, classes } = this.props
            return (
                canidates.map((canidate, key) => {
                        if(typeof(this.props.connectedCanidate)!=='undefined' && canidate.id===this.props.connectedCanidate.id) {
                          return null
                        }
                       return  (
                            <Card
                                style={this.state[key]}
                                key={canidate.id}
                                className={classes.card}
                                onClick={()=>this.onClick(key)}
                            >
                                <Typography color='inherit' variant='subheading'>
                                    {canidate.name}
                                </Typography>
                            
                            </Card>
                        )
                })
            )
        }
    
    render () {
        const {classes, canidates } = this.props
      
        return (
            <div>
            
            <Paper className={classes.paper}>
                <Typography variant="headline" color='primary' gutterBottom>
                   Helfer auswählen
                </Typography>
                {canidates
                    ? this.renderCanidates()
                    : null
                }
            </Paper>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    canidatesIds: state.adminCanidateState.currentOpenEvent.canidates,
    canidates: state.adminCanidateState.canidates

})

const mapDispatchToProps = (dispatch) => ({
    onFetchCanidates: (canidatesIds)=>fetchCanidates(canidatesIds),
    onSelectCanidate: (selectedCanidate)=>dispatch({type: SELECTED_CANIDATE, payload: selectedCanidate})

})


export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles)
    )(AdminCanidateSelect)



// WEBPACK FOOTER //
// ./src/Components/Admin/AdminEvents/AdminEventDetails/CanidateSelect.js